var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overview -page"},[_c('h2',[_vm._v("Feed")]),_c('p',[_vm._v("soon..")])])}]

export { render, staticRenderFns }